export type TOrderType = 'asc' | 'desc';

export const parseQueryParamOrder = (
  searchParams: URLSearchParams,
  defaults: { orderBy: string; orderType: TOrderType },
) => {
  const orderBy = searchParams.get('orderBy') || defaults.orderBy;
  const rawType = (searchParams.get('orderType') || defaults.orderType).toLowerCase();
  const orderType: TOrderType = rawType === 'asc' ? 'asc' : 'desc';

  return { orderBy, orderType };
};
